import { orderStatus } from "../../constants/labels";

export const panelSx = {
  border: "1px solid #e5e7eb",
  borderRadius: "8px",
  bgcolor: "#fff",
  boxShadow: "0 6px 18px rgba(15, 23, 42, 0.035)",
};

export const orderStatusLabel = orderStatus;

export const isActionNeeded = (line) =>
  ["NOT_REVIEWED", "REPLAN_REQUIRED"].includes(line.production_plan_status) ||
  ["CHECK_REQUIRED", "CHANGE_REVIEW"].includes(line.schedule_status) ||
  ["HIGH", "OVERDUE"].includes(line.risk_level);

export const getLineActionReason = (line, riskLevel, scheduleStatus) => {
  if (["HIGH", "OVERDUE"].includes(line.risk_level)) return riskLevel[line.risk_level]?.label || "납기 위험";
  if (line.schedule_status === "CHANGE_REVIEW") return scheduleStatus.CHANGE_REVIEW.label;
  if (line.schedule_status === "CHECK_REQUIRED") return scheduleStatus.CHECK_REQUIRED.label;
  if (["NOT_REVIEWED", "REPLAN_REQUIRED"].includes(line.production_plan_status)) return "생산계획 확인";
  return "조치 처리";
};
